import { render, staticRenderFns } from "./pd-credibility-quotes.vue?vue&type=template&id=0625323e&"
import script from "./pd-credibility-quotes.vue?vue&type=script&lang=js&"
export * from "./pd-credibility-quotes.vue?vue&type=script&lang=js&"
import style0 from "./pd-credibility-quotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default,Slider: require('/opt/build/repo/storefront/components/legacy/global/slider.vue').default})
